import * as React from 'react';
import { Button, Grid, Icon, IconSize, IconType, ModalWindow, Spinner, SpinnerSize } from 'ui-toolkit';

interface IEditModalWindowProps {
  title: string;
  updateButtonText?: string;
  showSaveSpinner: boolean;
  showSaveSuccess: boolean;
  disableUpdateButton: boolean;
  onUpdateDocument: () => void;
  onClose: () => void;
  children: React.ReactNode;
}

// tslint:disable-next-line:function-name
const EditModalWindow: React.FunctionComponent<IEditModalWindowProps> = (props) => {
  return (
    <ModalWindow uitype={'fit'} onClose={props.onClose}>
      <Grid>
        <h2>{props.title}</h2>
        {props.children}
        <Grid
          columnCount={props.showSaveSpinner || props.showSaveSuccess ? 3 : 2}
          alignItems={'center'}
          width={'min-content'}
          columnWidth={'min-content'}
        >
          {props.showSaveSpinner ? <Spinner size={SpinnerSize.small} /> : null}
          {props.showSaveSuccess ? <Icon type={IconType.Check} size={IconSize.Small} /> : null}
          <Button
            intent="primary"
            onClick={props.onUpdateDocument}
            className={props.disableUpdateButton ? '' : ' primary-button--disable'}
          >
            {props.updateButtonText ? props.updateButtonText : props.title}
          </Button>
          <Button intent="ghost" isInline onClick={props.onClose}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </ModalWindow>
  );
};

export default EditModalWindow;
